<h2 class="content-block">Meus dados</h2>
<div class="content-block">
  <div class="dx-card responsive-paddings">
  </div>
</div>
